import { useEffect } from 'react';

/**
 * アプリ全体の安全網。
 *
 * どのドロップ領域も受け取らなかったファイルのドロップを最後に止める。
 * これが無いと、ブラウザが既定動作としてPDFや画像を開いてしまい、作業中の
 * 画面から離脱してしまう（アップロードもされない）。
 * ドロップ領域側が preventDefault した場合は何もしない。
 */
export default function GlobalDropGuard() {
  useEffect(() => {
    const hasFiles = (e) => {
      const dt = e.dataTransfer;
      if (!dt) return false;
      if (dt.types && Array.from(dt.types).includes('Files')) return true;
      return !!(dt.items && Array.from(dt.items).some((i) => i.kind === 'file'));
    };
    const isNative = (e) => !!(e.target && e.target.closest
      && e.target.closest('input[type="file"], [data-native-drop]'));
    const guard = (e) => {
      if (!hasFiles(e) || isNative(e)) return;
      // このガードが止めたことを示す印。ページ側のドロップ処理は「他の領域が
      // 処理済み」と誤判定してはならない（iter_294）。
      if (!e.defaultPrevented) e.__sensbeyGuardOnly = true;
      e.preventDefault();          // 既定の「ファイルを開く」を常に止める
    };
    const onOver = guard;
    const onDrop = guard;
    document.addEventListener('dragover', onOver);
    document.addEventListener('drop', onDrop);
    return () => {
      document.removeEventListener('dragover', onOver);
      document.removeEventListener('drop', onDrop);
    };
  }, []);
  return null;
}
